const hotelData = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_HOTEL_DATA':
            return action.hotelData
        default:
            return state
    }
}

export default hotelData
